import {Box} from "@mui/material";
import {DetailsButton} from "../../buttons/DetailsButton";
import {ViewCompareList} from "../../buttons/ViewCompareList";
import {AddToCompareListButton} from "../../buttons/AddToCompareListButton";
import {AddToFavoritesButton} from "../../buttons/AddToFavoritesButton";
import React, {FC} from "react";

interface IButtonsGroupMotoTableCard {
    handleCompareClick: () => void;
    handleToggleFavorite: () => void;
    isInCompareList: boolean;
    isFavourite: boolean;
    compareArrayLength: number;
    navigateToDetailsPath: string;
    navigateToComparePath: string;
    mobileMode: boolean;
}

export const ButtonsGroupMotoTableCard: FC<IButtonsGroupMotoTableCard> = ({
    handleCompareClick,
    handleToggleFavorite,
    isInCompareList,
    isFavourite,
    compareArrayLength,
    navigateToDetailsPath,
    navigateToComparePath,
    mobileMode,
}) => {
    return (
        <Box sx={{display: "flex", justifyContent: "flex-end", alignItems: "center", position: "relative"}}>
            <DetailsButton
                navigateToDetailsPath={navigateToDetailsPath}
                mobileMode={mobileMode}
            />
            <ViewCompareList
                navigateToComparePath={navigateToComparePath}
                isListAvailable={compareArrayLength > 0}
                mobileMode={mobileMode}
            />
            <AddToCompareListButton
                onClick={handleCompareClick}
                isAddedToList={isInCompareList}
                mobileMode={mobileMode}
            />
            <AddToFavoritesButton
                onClick={handleToggleFavorite}
                isFavourite={isFavourite}
                mobileMode={mobileMode}/>
        </Box>
    );
};
